/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MensagensResumoAliases {
  AVATAR_0 = 'avatar-0',
  DECK_MENSAGENS = 'deck-mensagens',
  FETCH_MENSAGENS = 'fetch-mensagens',
  FIELD_0 = 'field-0',
  HPMS_CUSTOM_CARD_MENSAGENS = 'hpms-custom-card-mensagens',
  LAYOUT_0 = 'layout-0',
  LINK_MOSTRAR_TODAS_MENSAGENS = 'link-mostrar-todas-mensagens',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_MOSTRA_TODAS_MENSAGENS = 'panel-mostra-todas-mensagens',
  TEXT_0 = 'text-0',
}
export { MensagensResumoAliases };
